export default {
  valuesContainer: 'opacity-100 trasition-opacity duration-100 ease-in',
  valuesContainerHidden: 'opacity-0',
  titleWrapper:
    'h-[32px] mt-[32px] mb-[12px] flex items-center bg-[#E6EEF3] px-[10px] rounded',
  titleText: 'font-inter text-[14px] text-[#585D69] uppercase',
  detailsContainer:
    'flex justify-end fixed top-0 bottom-0 md:left-0 md:right-0 bg-[#10182880] overflow-y-scroll z-20',
  detailsModal: 'h-fit min-h-screen md:w-[725px] bg-color-white pt-[28px] px-[18px] w-[350px]',
  iconWrapper:
    'flex items-center justify-center h-[24px] w-[24px] bg-[#E7E8EA] rounded-full cursor-pointer',
  header: 'flex items-center justify-between mt-8 mb-[12px]',
  headerTitle: 'font-interSemibold text-[24px]',
  rightContent: 'flex bg-red items-center gap-5 ml-auto mr-[18px]',
  date: 'font-inter text-[16px] text-[#585D69]',
  info: 'font-inter text-[16px] text-color-text leading-[24px]',
  closeIcon:
    'flex items-center justify-center min-h-[24px] min-w-[24px] bg-color-white rounded-full cursor-pointer',
  formItem: 'flex mb-[18px] px-2',
  formKey: 'inline-block w-3/5 font-inter font-semibold capitalize',
  formValue: 'inline-block font-normal ml-8 break-words w-2/5',
  formNested: 'pl-12',
  formItemTopic: 'mb-[12px] capitalize pl-2 font-bold text-[18px] only:hidden',
};
